export const transformVideoGameRatingDto = videoGameRating => {
  const {
    id,
    title
  } = videoGameRating;
  return {
    id,
    title
  };
};
export const transformVideoGameRatingDtos = videoGameRatings => videoGameRatings.map(transformVideoGameRatingDto);